import type { RequestResponse, RequestsApiRequestBody } from './requestsHttpClient'

export { SupplierProductPayloadSchema } from '../libs/domain/supplierProductPayloadSchema'
export { ProductAndServicePayloadSchema } from '../libs/domain/productAndServicePayloadSchema'
export type {
  FormQuestionDiffValue,
  SupplierProductOriginalValue,
} from '../lambdas/getRequestFormDiffValues/FormQuestionDiffValue'
export type { RequestFormDetailResponse, RequestFormGeneralInfo } from '../lambdas/getRequestForm/getRequestFormSchema'
export type { GetSupplierRequestFormsResponse } from '../lambdas/getSupplierRequestForms/getSupplierRequestFormsSchema'
export type {
  BulkRequestFormSubmissionRequest,
  BulkRequestFormSubmissionResponse,
  OneSchemaData,
} from '../lambdas/bulkRequestFormSubmission/BulkRequestFormSubmissionSchema'
export type { InsertRequestFormSubmissionInput } from '../lambdas/createRequestFormSubmission/createRequestFormSubmissionSchema'
export type { GetSupplierStepsResponse, SupplierStepTask } from '../lambdas/getSupplierSteps/getSupplierStepsSchema'
export type { ListRequestsBody } from '../lambdas/listRequestsPaginated/listRequestsPaginatedSchema'
export type { UpdateRequestPropertiesInput } from '../lambdas/updateRequestProperties/updateRequestPropertiesSchema'
export type { GetResolvedNotificationMessageResponse } from '../lambdas/getResolvedNotificationMessage/getResolvedNotificationMessageSchema'
export type { RequestUser } from '../lambdas/getRequest/getRequestSchema'
export type { RequestDetail } from '../lambdas/getRequest/helpers/types'
export type {
  DetailedRequestStepTaskError,
  RequestStepTaskError,
} from '../lambdas/getRequestStepTaskErrors/getRequestStepTaskErrorsSchema'
export type {
  RequestStep,
  GetRequestStepsResponse,
  RequestStepTaskRejection,
} from '../lambdas/getRequestSteps/getRequestStepsLambdaSchema'
export type { GetRequestFormsResponse } from '../lambdas/getRequestForms/getRequestFormsSchema'
export type { GetChildRequestLinksResponse } from '../lambdas/getChildRequestLinks/getChildRequestLinksSchema'
export type { GetParentRequestLinkResponse } from '../lambdas/getParentRequestLink/getParentRequestLinkSchema'
export type { DuplicateRequestBody, DuplicateRequestResponse } from '../lambdas/duplicateRequest/duplicateRequestSchema'
export { getProtectedExtOpsQuestionIds } from '../lambdas/handleExtOpsIntegrationEnabled/data'
export {
  CreditsafeQuestionIds,
  CreditsafeQuestionIdsArray,
  CreditsafeQuestionTemplatesArray,
} from '../lambdas/handleExtOpsIntegrationEnabled/data/creditsafe'
export {
  ThomsonReutersQuestionIds,
  ThomsonReutersQuestionIdsArray,
  ThomsonReutersQuestionTemplatesArray,
} from '../lambdas/handleExtOpsIntegrationEnabled/data/thomsonReuters'
export {
  TprmContinuousMonitoringQuestionIds,
  TprmContinuousMonitoringQuestionIdsArray,
  TprmContinuousMonitoringQuestionTemplatesArray,
} from '../lambdas/handleExtOpsIntegrationEnabled/data/tprmContinuousIntegration'
export type { ExternalContact } from '../lambdas/prefillRequestForm/helpers/prefillSupplierFields/prefillStandardSupplierFields/getStandardSupplierPrefillFields'
export type { UncompleteRequestStepTaskResponse } from '../lambdas/uncompleteRequestStepTask/uncompleteRequestStepTaskSchema'
export type { FormAssignee, FormAssigneeType, ProductAndServicePayload } from '../libs/domain/productAndServicePayloadSchema'
export type { RequestTopLevelFilterKey } from '../libs/domain/requestsTopLevelFilterKeys'
export { keysByUserType } from '../libs/domain/requestsTopLevelFilterKeys'
export { quillVariableObjectRegex } from '../lambdas/getResolvedNotificationMessage/helpers/quillVariableObjectRegex'
export { convertHtmlWithMentionsToStandardFormat } from '../lambdas/getResolvedNotificationMessage/helpers/convertHtmlWithMentionsToStandardFormat'
export type { SupplierProductPayload, SupplierProductPayloadSupplier } from '../libs/domain/supplierProductPayloadSchema'
export { isSupplierProductPayload } from '../libs/domain/supplierProductPayloadSchema'
export type { AssigneeEntity } from '../libs/domain/sharedSchemas'
export { TaskStatusEnum } from '../libs/domain/taskStatus'
export { AssigneeSchema } from '../libs/domain/sharedSchemas'

export type GenerateRequestFormReviewRequest = RequestsApiRequestBody<
  '/request-form-submissions/{requestFormSubmissionId}/generate-review',
  'post'
>
export type GenerateRequestFormReviewResponse = NonNullable<
  RequestResponse<'/request-form-submissions/{requestFormSubmissionId}/generate-review', 'post'>['data']
>

export type UpdateRequestFormReviewIssueStatusRequest = RequestsApiRequestBody<
  '/request-form-review-issues/{formReviewIssueId}',
  'post'
>
export type UpdateRequestFormReviewIssueStatusResponse = NonNullable<
  RequestResponse<'/request-form-review-issues/{formReviewIssueId}', 'post'>['data']
>

export type ReviewIssue = GenerateRequestFormReviewResponse['issues'][number]
